<template>
  <div class="d-flex px-6 pt-4 pb-2 text-caption text-secondary main">
    <v-icon
      class="mr-2"
      size="16"
    >
      ico-sm-switch-vertical
    </v-icon>
    <div class="mr-4">
      {{ t('autocomplete.select') }}
    </div>
    <v-icon
      size="16"
      class="mr-2"
    >
      ico-sm-enter
    </v-icon>
    <span>{{ t('autocomplete.open') }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { useI18n } from '@src/composables/useI18n'

export default defineComponent({
  name: 'SearchShortcuts',
  setup() {
    const { t } = useI18n()
    return { t }
  }
})

</script>

<style lang="scss" scoped>
.main {
  border-top: 1px solid rgba(0, 0, 0, 0.12);;
}

</style>
